// @flow
import React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type Props = {
  classes: Object,
  value: string,
  options: string[],
  error: string,
  colorTheme: string,
  onChange: Function
}

function Dropdown({ classes: c, value, options, error, onChange }: Props) {
  return (
    <div>
      <div className={c.container}>
        <select value={value} className={classNames(c.control, value && c.selected)} onChange={e => onChange(e.target.value)}>
          <option className={c.disabled} value="" disabled>Select Country</option>
          {options.map(option =>
            <option
              key={option}
              value={option}
            >{option}</option>
          )}
        </select>
      </div>
      { error &&
        <span className={c.errorMsg}>
          <i className="material-icons">error</i>
          {error}
        </span>
      }
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    '&:after': {
      content: '"\\E5C5"',
      position: 'absolute',
      fontFamily: 'Material Icons',
      color: 'gray',
      right: '0',
      top: '0',
      bottom: '0',
      fontSize: '30px',
      lineHeight: '48px',
      pointerEvents: 'none'
    }
  },
  control: {
    fontFamily: FONT_FAMILY_ROBOTO,
    border: 'none',
    borderBottom: '1px solid hsl(0, 0%, 20%)',
    backgroundColor: 'transparent',
    borderRadius: '0',
    display: 'inline-block',
    letterSpacing: '0',
    padding: '14px 5px',
    fontSize: '16px',
    appearance: 'none',
    color: 'gray',
    fontWeight: '300',
    width: '100%',
    transition: 'background-color .25s',
    cursor: 'pointer',
  },
  selected: {
    color: (props) => {
      if (props.colorTheme === 'DARK') {
        return 'white';
      }
      return 'black';
    }
  },
  errorMsg: {
    color: 'hsl(360, 100%, 40%)',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
    '&> .material-icons': {
      fontSize: '18px',
      marginRight: '5px'
    }
  },
  disabled: {
    color: 'hsl(0, 0%, 70%)'
  }
};

export default injectSheet(styles)(Dropdown);
